import { Menu, rem } from "@mantine/core";
import { IconLogout } from "@tabler/icons-react";
import React from "react";
import useAuth from "@/hooks/useAuth";
import UserButton from "./UserButton";
import classes from "./UserMenu.module.css";

const UserMenu: React.FC = () => {
  const { authUser, logout } = useAuth();

  const handleLogoutClick = () => {
    logout();
  };

  return (
    <Menu position="bottom-end">
      <Menu.Target>
        <UserButton
          role={authUser?.role ?? ""}
          name={authUser?.name ?? ""}
          className={classes.user}
        />
      </Menu.Target>

      <Menu.Dropdown className={classes.dropdown}>
        <Menu.Item
          leftSection={<IconLogout style={{ width: rem(28), height: rem(28) }} />}
          component="button"
          style={{
            paddingTop: rem(12),
            height: rem(48),
          }}
          onClick={handleLogoutClick}
        >
          ログアウト
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default UserMenu;
